import BitterSweet from "./Bittersweetsposter.png";
import BvDoshi from "./BVdoshi.png";
import RightForward from "./Rightforward.png";
import ShikshaKaSuraj from "./ShikshaKaSuraj.png";
import SkodaPrize from "./SKODAPRIZE.png";
import TheLastDance from "./Thelastdance.png";

export const shortsanddocAssets = {
  BitterSweet,
  BvDoshi,
  RightForward,
  ShikshaKaSuraj,
  SkodaPrize,
  TheLastDance,
};
